import React from "react";
import { whatsappLink } from "@/lib/apiClient";

export const WhatsAppButton = () => (
  <a
    data-testid="whatsapp-button"
    href={whatsappLink()}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-20 md:bottom-5 left-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-3 pr-4 py-3 shadow-lg hover:scale-105 active:scale-95 transition-transform"
    aria-label="Chat on WhatsApp"
  >
    <svg viewBox="0 0 32 32" className="h-6 w-6 fill-current">
      <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.646.86 5.09 2.316 7.083L4.2 29l7.1-2.06a11.94 11.94 0 004.703.96h.001C22.62 27.9 28 22.518 28 15.9 28 9.28 22.62 3 16.003 3zm0 21.8h-.001a9.9 9.9 0 01-5.043-1.38l-.362-.215-4.213 1.222 1.246-4.104-.236-.377a9.86 9.86 0 01-1.51-5.246c0-5.47 4.45-9.92 9.922-9.92 2.65 0 5.14 1.033 7.014 2.907a9.85 9.85 0 012.906 7.017c0 5.47-4.45 9.92-9.92 9.92z" />
    </svg>
    <span className="text-sm font-semibold hidden sm:inline">WhatsApp</span>
  </a>
);
